export function getTodayDate(): string {
  const now = new Date();

  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = String(now.getFullYear()).padStart(4, "0");

  return `${day}-${month}-${year}`;
}

export default function isDateToday(availabilityDate: string) {
  return availabilityDate === getTodayDate();
}
